// extracted by mini-css-extract-plugin
export default {"main":"AnketaSend_main__aJEpp","content":"AnketaSend_content__3z9zo","text":"AnketaSend_text__SBTug","buttons":"AnketaSend_buttons__9rdwB","btn":"AnketaSend_btn__DchK2"};